<template>
  <div class="CommonInfo">
    <ld-header transparent />

    <van-tabs
      v-model="active"
      line-height="2px"
      line-width="20px"
      sticky
      swipeable
    >
      <van-tab
        name="1"
        title="常用旅客"
      >
        <van-search
          v-model="contactPage.queryStr"
          background="transparent"
          placeholder="姓名/编号/手机号"
          @input="onRefresh(contactPage)"
        />
        <div class="wrapper">
          <mescroll-vue
            ref="mescroll"
            :down="down"
          >
            <van-pull-refresh
              v-model="contactPage.pullRefreshLoading"
              @refresh="onRefresh(contactPage)"
            >
              <van-list
                v-model="contactPage.loading"
                :error-text="contactPage.errorText"
                :error.sync="contactPage.error"
                :finished="contactPage.finished"
                :finished-text="contactPage.finishedText"
                @load="getContactList(contactPage.pageNum++)"
              >
                <van-row
                  v-for="(contact, i) in contactPage.list"
                  :key="i"
                  align="center"
                  class="common-item bg-white"
                  type="flex"
                >
                  <van-col :span="20">
                    <h4 class="common-item__title">
                      <span v-if="contact.chName">{{ contact.chName }} {{ contact.phoneNumber }}</span>
                      <span v-else>{{ contact.enName }} {{ contact.phoneNumber }}</span>
                    </h4>
                    <div class="common-item__label">
                      {{ contact.cardName }} {{ contact.cardNo }}
                    </div>
                  </van-col>
                  <van-col
                    :span="4"
                    class="text-center"
                    @click.stop="editCon(contact)"
                  >
                    <van-icon
                      name="edit"
                      size="18"
                    />
                  </van-col>
                </van-row>
              </van-list>
            </van-pull-refresh>
          </mescroll-vue>
        </div>
      </van-tab>


      <van-tab
        name="2"
        title="常用地址"
      >
        <div class="wrapper">
          <mescroll-vue
            ref="mescroll"
            :down="down"
          >
            <van-list
              v-model="addressPage.loading"
              :error-text="addressPage.errorText"
              :error.sync="addressPage.error"
              :finished="addressPage.finished"
              :finished-text="addressPage.finishedText"
              @load="getAddressList()"
            >
              <van-row
                v-for="(address, i) in addressPage.list"
                :key="i"
                align="center"
                class="common-item bg-white"
                type="flex"
              >
                <van-col :span="20">
                  <h4 class="common-item__title">
                    {{ address.recipient }} {{ address.phoneNumber }}
                  </h4>
                  <div class="common-item__label">
                    {{ address.addr }}
                  </div>
                  <div class="common-item__label">
                    {{ address.post }}
                  </div>
                </van-col>
                <van-col
                  :span="4"
                  class="text-center"
                  @click.stop="editAddress(address)"
                >
                  <van-icon
                    name="edit"
                    size="18"
                  />
                </van-col>
              </van-row>
            </van-list>
          </mescroll-vue>
        </div>
      </van-tab>
    </van-tabs>

    <div
      class="add-btn linear-main2 add ballStyle"
      @click="add"
      ref="deviceInfo"
      @mousedown="down1()"
      @touchstart="down1()"
      @mousemove="move1()"
      @touchmove="move1()"
      @mouseup="end1()"
      @touchend="end1()"
    >
      <van-icon
        color="#fff"
        name="plus"
        size="34"
      />
    </div>
  </div>
</template>

<script>
import {List, PullRefresh, Search, Tab, Tabs} from 'vant'
import MescrollVue from 'mescroll.js/mescroll.vue'
import contactsInteractor from 'Domain/use-cases/contacts-interactor'
import vipEmpFSInteractor from 'Domain/use-cases/vipEmpFS-interactor'
import addressInteractor from 'Domain/use-cases/address-interactor'

export default {
  name: 'CommonInfo',
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Search.name]: Search,
    MescrollVue,
  },
  data() {
    return {
      flags: false,
      position: {x: 0, y: 0},
      active: 1,
      contactPage: {
        queryStr: '',
        pageNum: 0,
        count: 10,
        loading: false,
        finished: false,
        finishedText: '没有更多数据了~',
        error: false,
        errorText: '请求失败，点击重新加载',
        pullRefreshLoading: false,
        list: [],
        searchName: 'getContactList',
      },
      vipEmpFSPage: {
        pageNum: 0,
        count: 10,
        loading: false,
        finished: false,
        finishedText: '没有更多数据了~',
        error: false,
        errorText: '请求失败，点击重新加载',
        pullRefreshLoading: false,
        list: [],
        searchName: 'getVipEmpFSList',
      },
      addressPage: {
        loading: false,
        finished: false,
        finishedText: '没有更多数据了~',
        error: false,
        errorText: '请求失败，点击重新加载',
        pullRefreshLoading: false,
        list: [],
        searchName: 'getAddressList',
      },
      down: {use: false},
    }
  },
  methods: {
    add() {
      if (this.active == 1) {
        this.$router.push({path: '/userCenter/CommonInfo/EditContact'})
      } else {
        this.$router.push({path: '/userCenter/CommonInfo/EditAddress'})
      }
    },
    onRefresh(page) {
      page.list = []
      page.pageNum = 1
      page.pullRefreshLoading = false
      page.finished = false
      this[page.searchName]()
    },
    /**
     * 获取常旅客列表
     */
    async getContactList() {
      try {
        if (this.contactPage.pageNum === 0) return

        this.contactPage.loading = true
        let params = {
          queryStr: this.contactPage.queryStr,
          pageNum: this.contactPage.pageNum,
          count: this.contactPage.count
        }
        const {data} = await contactsInteractor.getContactsList(params)

        this.contactPage.loading = false
        if (data.length < this.contactPage.count) {
          this.contactPage.finished = true
        }

        if (params.pageNum > 1) {
          this.contactPage.list.push(...data)
        } else {
          this.contactPage.list = data
        }

      } catch (error) {
        this.contactPage.error = true
      }
    },
    editContact({id}) {
      this.$router.push({path: `/userCenter/CommonInfo/EditContact/${id}`})
    },
    editCon({id}) {
      this.$router.push({path: `/userCenter/CommonInfo/EditConta1/${id}`})
    },
    down1() {
      const moveDiv = this.$refs.deviceInfo
      this.flags = true
      let touch
      if (event.touches) {
        touch = event.touches[0] //获取当前事件
      } else {
        touch = event
      }
      this.position.x = touch.clientX //获取手指位置坐标
      this.position.y = touch.clientY
      this.dx = moveDiv.offsetLeft //获取小球相对于离它最近的（指包含层级上的最近）包含小球的定位元素或者最近的 table,td,th,body元素左部内边距的距离
      this.dy = moveDiv.offsetTop
    },
    move1() {
      const moveDiv = this.$refs.deviceInfo
      if (this.flags) {
        let touch
        if (event.touches) {
          touch = event.touches[0]
        } else {
          touch = event
        }
        this.nx = touch.clientX - this.position.x //手指横向移动距离
        this.ny = touch.clientY - this.position.y
        this.xPum = this.dx + this.nx //计算小球移动后的位置
        this.yPum = this.dy + this.ny

        moveDiv.style.left = this.xPum + 'px' //将计算得到的位置赋值给style
        moveDiv.style.top = this.yPum + 'px'
      }
    },
    //鼠标释放时候的函数
    end1() {
      this.flags = false
    },
    /**
     * 删除常旅客
     */
    deleteContact({contactsId}) {
      this.$dialog.confirm({
        message: '确定删除吗？'
      }).then(async () => {
        await contactsInteractor.deleteContacts(contactsId)
        this.$dialog({message: '删除成功！'})
        this.getContactList()
      })
    },
    /**
     * 获取常用地址列表
     */
    async getAddressList() {
      try {
        this.addressPage.loading = true
        const {data} = await addressInteractor.getAddressList()

        this.addressPage.loading = false
        this.addressPage.finished = true

        this.addressPage.list = data

      } catch (error) {
        this.addressPage.error = true
      }
    },
    editAddress({id}) {
      this.$router.push({path: `/userCenter/CommonInfo/EditAddress/${id}`})
    },
    /**
     * 获取员工附属人列表
     */
    async getVipEmpFSList() {
      try {
        if (this.vipEmpFSPage.pageNum === 0) return

        this.vipEmpFSPage.loading = true
        let params = {
          pageNum: this.vipEmpFSPage.pageNum,
          count: this.vipEmpFSPage.count
        }
        const {data} = await vipEmpFSInteractor.getVipEmpFSList(params)

        this.vipEmpFSPage.loading = false
        if (data.length < this.vipEmpFSPage.count) {
          this.vipEmpFSPage.finished = true
        }
        if (params.pageNum > 1) {
          this.vipEmpFSPage.list.push(...data)
        } else {
          this.vipEmpFSPage.list = data
        }

      } catch (error) {
        this.vipEmpFSPage.error = true
      }
    }
  }
}
</script>

<style lang="less">
.CommonInfo {
  h3, h4 {
    margin: 0;
  }

  .wrapper {
    height: calc(100vh - 150px);
    overflow: hidden;
    padding: 0 8px;
  }

  .van-tabs__nav {
    background-color: transparent;
  }

  .van-search__content {
    background-color: #fff;
  }

  .van-tabs__wrap {
    width: 300px;

    .van-tab--active {
      font-size: @font-size-20;
      z-index: 1;
    }

  }

  .common-item {
    padding: 13px 15px;
    border-radius: @border-radius-sm;
    margin-top: 5px;

    .common-item__label {
      margin-top: 5px;
      font-size: @font-size-12;
      color: @color-text-gray;
    }
  }

  .add-btn {
    position: fixed;
    right: 20px;
    bottom: 60px;
    padding: 10px;
    border-radius: 50%;
    font-size: 0;
    box-shadow: 0px 13px 18px 0px rgba(201, 153, 94, 0.23);
  }
}

.add-btn {
  position: fixed;
  right: 20px;
  bottom: 60px;
  padding: 10px;
  border-radius: 50%;
  font-size: 0;
  box-shadow: 0px 13px 18px 0px rgba(201, 153, 94, 0.23);


}

.ballStyle {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  background-image: -webkit-linear-gradient(left, rgb(198, 221, 229) 1%, rgb(215, 225, 229) 100%) !important;
  //background-image: -webkit-linear-gradient(right, #eb6100 0%, #ffc63e 100%);
  border-radius: 50%;
  touch-action: none;
  /*防止谷歌浏览器监听touch事件时报错*/
  animation: light 2s ease-in-out infinite alternate;
  position: relative;
  /*没有这个小球动不了*/
}

@keyframes light {
  from {
    box-shadow: 0 0 4px #dbde14;

  }

  to {
    box-shadow: 0 0 20px #eb6100
  }
}
</style>
